import { Outlet } from "react-router"
import { useAuthState } from "~/context/auth"
import { startOAuthFlow } from "~/services/oauth"

export const RequireAuth = () => {
  const { isAuthenticated, isLoading } = useAuthState()

  // While checking session show nothing
  if (isLoading) {
    return null
  }

  if (!isAuthenticated) {
    /* If the user is not authenticated, start auth flow
       There is no way users can go back to the route without valid session, so we replace the current history entry */
    startOAuthFlow({ replaceCurrentHistoryEntry: true }).catch((error) => {
      console.error("[RequireAuth] Failed to start OAuth flow:", error)
    })
    return null
  }

  return <Outlet />
}
